import type { Dayjs } from "dayjs";

export const formatTimestampWithOffset = (timestamp: Dayjs): string =>
  timestamp.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
